// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Compatibility Layer for Bootstrap 4.3.1 to 5.3.6 */

:root {
    --bs-border-color: rgba(0, 0, 0, 0.125);
}

.text-left {
    text-align: left !important;
}

.text-right {
    text-align: right !important;
}

.float-left {
    float: left !important;
}

.float-right {
    float: right !important;
}

.dropdown-menu-right,
.dropdown-menu-end {
    right: 0;
    left: auto;
}

.badge-pill {
    border-radius: 50rem !important;
}

.form-row {
    display: flex;
    flex-wrap: wrap;
}

.form-row>.col,
.form-row>[class*="col-"] {
    padding-right: 5px;
    padding-left: 5px;
}

.btn-block {
    display: block;
    width: 100% !important;
}

.btn-link {
    text-decoration: none;
}

.ml-0 {
    margin-left: 0 !important;
}

.ml-1 {
    margin-left: 0.25rem !important;
}

.ml-2 {
    margin-left: 0.5rem !important;
}

.ml-3 {
    margin-left: 1rem !important;
}

.ml-4 {
    margin-left: 1.5rem !important;
}

.ml-5 {
    margin-left: 3rem !important;
}

.mr-0 {
    margin-right: 0 !important;
}

.mr-1 {
    margin-right: 0.25rem !important;
}

.mr-2 {
    margin-right: 0.5rem !important;
}

.mr-3 {
    margin-right: 1rem !important;
}

.mr-4 {
    margin-right: 1.5rem !important;
}

.mr-5 {
    margin-right: 3rem !important;
}

.pl-0 {
    padding-left: 0 !important;
}

.pl-1 {
    padding-left: 0.25rem !important;
}

.pl-2 {
    padding-left: 0.5rem !important;
}

.pl-3 {
    padding-left: 1rem !important;
}

.pl-4 {
    padding-left: 1.5rem !important;
}

.pl-5 {
    padding-left: 3rem !important;
}

.pr-0 {
    padding-right: 0 !important;
}

.pr-1 {
    padding-right: 0.25rem !important;
}

.pr-2 {
    padding-right: 0.5rem !important;
}

.pr-3 {
    padding-right: 1rem !important;
}

.pr-4 {
    padding-right: 1.5rem !important;
}

.pr-5 {
    padding-right: 3rem !important;
}

.m-auto {
    margin: auto !important;
}

.mt-auto {
    margin-top: auto !important;
}

.mr-auto {
    margin-right: auto !important;
}

.mb-auto {
    margin-bottom: auto !important;
}

.ml-auto {
    margin-left: auto !important;
}

.mx-auto {
    margin-left: auto !important;
    margin-right: auto !important;
}

.my-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
}

.p-auto {
    padding: auto !important;
}

.pt-auto {
    padding-top: auto !important;
}

.pr-auto {
    padding-right: auto !important;
}

.pb-auto {
    padding-bottom: auto !important;
}

.pl-auto {
    padding-left: auto !important;
}

.px-auto {
    padding-left: auto !important;
    padding-right: auto !important;
}

.py-auto {
    padding-top: auto !important;
    padding-bottom: auto !important;
}

.form-inline {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    -ms-flex-align: center;
    align-items: center;
}

.form-group {
    margin-bottom: 1rem;
}

.clearfix::after {
    display: block;
    clear: both;
    content: "";
}

.badge {
    color: inherit;
}

.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

.sr-only-focusable:active,
.sr-only-focusable:focus {
    position: static;
    width: auto;
    height: auto;
    overflow: visible;
    clip: auto;
    white-space: normal;
}

[class*="col-"] {
    position: relative;
}

@media (min-width: 576px) {
    .form-inline label {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-pack: center;
        justify-content: center;
        margin-bottom: 0;
    }

    .form-inline .form-group {
        display: -ms-flexbox;
        display: flex;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        -ms-flex-flow: row wrap;
        flex-flow: row wrap;
        -ms-flex-align: center;
        align-items: center;
        margin-bottom: 0;
    }

    .form-inline .form-control {
        display: inline-block;
        width: auto;
        vertical-align: middle;
    }

    .form-inline .form-control-plaintext {
        display: inline-block;
    }

    .form-inline .input-group,
    .form-inline .custom-select {
        width: auto;
    }

    .form-inline .form-check {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-pack: center;
        justify-content: center;
        width: auto;
        padding-left: 0;
    }

    .form-inline .form-check-input {
        position: relative;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        margin-top: 0;
        margin-right: 0.25rem;
        margin-left: 0;
    }

    .form-inline .custom-control {
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-pack: center;
        justify-content: center;
    }

    .form-inline .custom-control-label {
        margin-bottom: 0;
    }
}

.table>thead:not(caption)>*>* {
    border-top-width: 2px;
    border-bottom-width: 2px;
}

.table>tfoot:not(caption)>*>* {
    border-bottom-width: 0;
}

.table>:not(caption)>*>* {
    background-color: unset;
}

.table>tbody>*:last-child {
    border-bottom: 1px solid #dee2e6;
}

.table th,
.table td {
    vertical-align: top;
    border-top: 1px solid #dee2e6;
}

.no-gutters {
    margin-right: 0;
    margin-left: 0;
}

.no-gutters>.col,
.no-gutters>[class*="col-"] {
    padding-right: 0;
    padding-left: 0;
}

.modal-header .close {
    padding: 1rem 1rem;
    margin: -1rem -1rem -1rem auto;
}

.list-group-item {
    --bs-list-group-item-padding-x: 1.25rem;
    --bs-list-group-item-padding-y: 0.75rem;
}

.btn {
    --bs-border-radius: 0.2rem;
}

button.close {
    border: 0;
}

.font-weight-light {
    font-weight: 300 !important;
}

.font-weight-lighter {
    font-weight: lighter !important;
}

.font-weight-normal {
    font-weight: 400 !important;
}

.font-weight-bold {
    font-weight: 700 !important;
}

.font-weight-bolder {
    font-weight: bolder !important;
}

.font-italic {
    font-style: italic !important;
}

legend {
    float: unset;
}

a {
    text-decoration: none;
}

a:hover {
    text-decoration: underline;
}

a:not([href]):not([class]) {
    color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
}

a:not([href]):not([class]):hover {
    color: rgba(var(--bs-link-hover-color-rgb), var(--bs-link-opacity, 1));
    text-decoration: underline;
}

button:focus:not(:focus-visible) {
    outline: 1px auto -webkit-focus-ring-color;
}

.list-group-item:first-child {
    border-top-right-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
}
.list-group-item:last-child {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
}
`, "",{"version":3,"sources":["webpack://./styles/bootstrap-polyfill.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;;IAEI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,oBAAoB;QACpB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,qBAAqB;QACrB,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;QACpB,aAAa;QACb,kBAAkB;QAClB,cAAc;QACd,uBAAuB;QACvB,mBAAmB;QACnB,sBAAsB;QACtB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;QACrB,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,oBAAoB;QACpB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,qBAAqB;QACrB,uBAAuB;QACvB,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,oBAAoB;QACpB,cAAc;QACd,aAAa;QACb,qBAAqB;QACrB,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,qBAAqB;QACrB,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,uCAAuC;IACvC,uCAAuC;AAC3C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,sEAAsE;IACtE,0BAA0B;AAC9B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;AACnC;AACA;IACI,mCAAmC;IACnC,kCAAkC;AACtC","sourcesContent":["/* Compatibility Layer for Bootstrap 4.3.1 to 5.3.6 */\n\n:root {\n    --bs-border-color: rgba(0, 0, 0, 0.125);\n}\n\n.text-left {\n    text-align: left !important;\n}\n\n.text-right {\n    text-align: right !important;\n}\n\n.float-left {\n    float: left !important;\n}\n\n.float-right {\n    float: right !important;\n}\n\n.dropdown-menu-right,\n.dropdown-menu-end {\n    right: 0;\n    left: auto;\n}\n\n.badge-pill {\n    border-radius: 50rem !important;\n}\n\n.form-row {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.form-row>.col,\n.form-row>[class*=\"col-\"] {\n    padding-right: 5px;\n    padding-left: 5px;\n}\n\n.btn-block {\n    display: block;\n    width: 100% !important;\n}\n\n.btn-link {\n    text-decoration: none;\n}\n\n.ml-0 {\n    margin-left: 0 !important;\n}\n\n.ml-1 {\n    margin-left: 0.25rem !important;\n}\n\n.ml-2 {\n    margin-left: 0.5rem !important;\n}\n\n.ml-3 {\n    margin-left: 1rem !important;\n}\n\n.ml-4 {\n    margin-left: 1.5rem !important;\n}\n\n.ml-5 {\n    margin-left: 3rem !important;\n}\n\n.mr-0 {\n    margin-right: 0 !important;\n}\n\n.mr-1 {\n    margin-right: 0.25rem !important;\n}\n\n.mr-2 {\n    margin-right: 0.5rem !important;\n}\n\n.mr-3 {\n    margin-right: 1rem !important;\n}\n\n.mr-4 {\n    margin-right: 1.5rem !important;\n}\n\n.mr-5 {\n    margin-right: 3rem !important;\n}\n\n.pl-0 {\n    padding-left: 0 !important;\n}\n\n.pl-1 {\n    padding-left: 0.25rem !important;\n}\n\n.pl-2 {\n    padding-left: 0.5rem !important;\n}\n\n.pl-3 {\n    padding-left: 1rem !important;\n}\n\n.pl-4 {\n    padding-left: 1.5rem !important;\n}\n\n.pl-5 {\n    padding-left: 3rem !important;\n}\n\n.pr-0 {\n    padding-right: 0 !important;\n}\n\n.pr-1 {\n    padding-right: 0.25rem !important;\n}\n\n.pr-2 {\n    padding-right: 0.5rem !important;\n}\n\n.pr-3 {\n    padding-right: 1rem !important;\n}\n\n.pr-4 {\n    padding-right: 1.5rem !important;\n}\n\n.pr-5 {\n    padding-right: 3rem !important;\n}\n\n.m-auto {\n    margin: auto !important;\n}\n\n.mt-auto {\n    margin-top: auto !important;\n}\n\n.mr-auto {\n    margin-right: auto !important;\n}\n\n.mb-auto {\n    margin-bottom: auto !important;\n}\n\n.ml-auto {\n    margin-left: auto !important;\n}\n\n.mx-auto {\n    margin-left: auto !important;\n    margin-right: auto !important;\n}\n\n.my-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n}\n\n.p-auto {\n    padding: auto !important;\n}\n\n.pt-auto {\n    padding-top: auto !important;\n}\n\n.pr-auto {\n    padding-right: auto !important;\n}\n\n.pb-auto {\n    padding-bottom: auto !important;\n}\n\n.pl-auto {\n    padding-left: auto !important;\n}\n\n.px-auto {\n    padding-left: auto !important;\n    padding-right: auto !important;\n}\n\n.py-auto {\n    padding-top: auto !important;\n    padding-bottom: auto !important;\n}\n\n.form-inline {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-flow: row wrap;\n    flex-flow: row wrap;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.form-group {\n    margin-bottom: 1rem;\n}\n\n.clearfix::after {\n    display: block;\n    clear: both;\n    content: \"\";\n}\n\n.badge {\n    color: inherit;\n}\n\n.sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n}\n\n.sr-only-focusable:active,\n.sr-only-focusable:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n}\n\n[class*=\"col-\"] {\n    position: relative;\n}\n\n@media (min-width: 576px) {\n    .form-inline label {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-align: center;\n        align-items: center;\n        -ms-flex-pack: center;\n        justify-content: center;\n        margin-bottom: 0;\n    }\n\n    .form-inline .form-group {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n        -ms-flex-flow: row wrap;\n        flex-flow: row wrap;\n        -ms-flex-align: center;\n        align-items: center;\n        margin-bottom: 0;\n    }\n\n    .form-inline .form-control {\n        display: inline-block;\n        width: auto;\n        vertical-align: middle;\n    }\n\n    .form-inline .form-control-plaintext {\n        display: inline-block;\n    }\n\n    .form-inline .input-group,\n    .form-inline .custom-select {\n        width: auto;\n    }\n\n    .form-inline .form-check {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-align: center;\n        align-items: center;\n        -ms-flex-pack: center;\n        justify-content: center;\n        width: auto;\n        padding-left: 0;\n    }\n\n    .form-inline .form-check-input {\n        position: relative;\n        -ms-flex-negative: 0;\n        flex-shrink: 0;\n        margin-top: 0;\n        margin-right: 0.25rem;\n        margin-left: 0;\n    }\n\n    .form-inline .custom-control {\n        -ms-flex-align: center;\n        align-items: center;\n        -ms-flex-pack: center;\n        justify-content: center;\n    }\n\n    .form-inline .custom-control-label {\n        margin-bottom: 0;\n    }\n}\n\n.table>thead:not(caption)>*>* {\n    border-top-width: 2px;\n    border-bottom-width: 2px;\n}\n\n.table>tfoot:not(caption)>*>* {\n    border-bottom-width: 0;\n}\n\n.table>:not(caption)>*>* {\n    background-color: unset;\n}\n\n.table>tbody>*:last-child {\n    border-bottom: 1px solid #dee2e6;\n}\n\n.table th,\n.table td {\n    vertical-align: top;\n    border-top: 1px solid #dee2e6;\n}\n\n.no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n}\n\n.no-gutters>.col,\n.no-gutters>[class*=\"col-\"] {\n    padding-right: 0;\n    padding-left: 0;\n}\n\n.modal-header .close {\n    padding: 1rem 1rem;\n    margin: -1rem -1rem -1rem auto;\n}\n\n.list-group-item {\n    --bs-list-group-item-padding-x: 1.25rem;\n    --bs-list-group-item-padding-y: 0.75rem;\n}\n\n.btn {\n    --bs-border-radius: 0.2rem;\n}\n\nbutton.close {\n    border: 0;\n}\n\n.font-weight-light {\n    font-weight: 300 !important;\n}\n\n.font-weight-lighter {\n    font-weight: lighter !important;\n}\n\n.font-weight-normal {\n    font-weight: 400 !important;\n}\n\n.font-weight-bold {\n    font-weight: 700 !important;\n}\n\n.font-weight-bolder {\n    font-weight: bolder !important;\n}\n\n.font-italic {\n    font-style: italic !important;\n}\n\nlegend {\n    float: unset;\n}\n\na {\n    text-decoration: none;\n}\n\na:hover {\n    text-decoration: underline;\n}\n\na:not([href]):not([class]) {\n    color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));\n}\n\na:not([href]):not([class]):hover {\n    color: rgba(var(--bs-link-hover-color-rgb), var(--bs-link-opacity, 1));\n    text-decoration: underline;\n}\n\nbutton:focus:not(:focus-visible) {\n    outline: 1px auto -webkit-focus-ring-color;\n}\n\n.list-group-item:first-child {\n    border-top-right-radius: 0.25rem;\n    border-top-left-radius: 0.25rem;\n}\n.list-group-item:last-child {\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
